import { render, staticRenderFns } from "./ui.vue?vue&type=template&id=241cb30f&"
import script from "./ui.vue?vue&type=script&lang=js&"
export * from "./ui.vue?vue&type=script&lang=js&"
import style0 from "./ui.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports